const key = "attendanceManagement";
const baseRoute = "/attendanceManagement";

export const Const = {

  breakType: {
    lngKey: `${key}.breakType`,
    route: ``,
  },
  attendanceConfiguration: {
    lngKey: `${key}.attendanceConfiguration`,
    route: ``,
  },
  attendanceRequest: {
    lngKey: `${key}.attendanceRequest`,
    route: ``,
  },
  attendanceApproval: {
    lngKey: `${key}.attendanceApproval`,
    route: ``,
  },
  overtimeRequest: {
    lngKey: `${key}.overtimeRequest`,
    route: ``,
  },
  overtimeApproval: {
    lngKey: `${key}.overtimeApproval`,
    route: ``,
  },
  attendanceLogs: {
    lngKey: `${key}.attendanceLogs`,
    route: ``,
  },
  myAttendance: {
    lngKey: `${key}.myAttendance`,
    route: ``,
  },

};

const cmn = "common";
export const Commons = {
  create: `${cmn}.create`,
  update: `${cmn}.update`,
  view: `${cmn}.view`,
  name: `${cmn}.name`,
  code: `${cmn}.code`,
  location: `${cmn}.location`,
  branch: `${cmn}.branch`,
  department: `${cmn}.department`,
  designation: `${cmn}.designation`,
  joiningDate: `${cmn}.joiningDate`,
  grade: `${cmn}.grade`,
  ProfileCompletion: `${cmn}.ProfileCompletion`,
  actions: `${cmn}.actions`,
  is_active: `${cmn}.is_active`,
  status: `${cmn}.status`,
  description: `${cmn}.description`,
  shortname: `${cmn}.shortname`,
  country: `${cmn}.country`,
  history: `${cmn}.history`,
  flow: `${cmn}.flow`,
};
export const colors = {
  "bg-warning": "#faad14",
  "bg-warning-color": "white",
  "bg-success": "green",
  "bg-success-color": "white",
  "bg-darkgray": "#333",
  "bg-danger": "#d9534f",
  "bg-off": "#36c2aa",
  "bg-info": "#f5791a",
  "bg-leave": "#107863",
  "bg-absent": "#a02622"
}
